module.exports = "<div class=\"zenDescIcon\" (click)=\"activate()\" *ngIf=\"isActive\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/core/zendesk-chat/zendesk-chat.component.html
// module id = Xx7i
// module chunks = 6